import { StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    width: '80%',
    maxWidth: 975,
    backgroundColor: neutrals.white,
    borderRadius: 28,
    padding: 24,
  },
  header: {
    width: '100%',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomColor: neutrals.neutralGrays.dust,
    borderBottomWidth: 1,
    paddingHorizontal: 18,
  },
  left_element: {
    flex: 1,
    alignItems: 'flex-start',
  },
  right_element: {
    flex: 1,
    alignItems: 'flex-end',
  },
  center_element: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    paddingVertical: 18,
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 24,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 16,
    textAlign: 'center',
    color: neutrals.neutralGrays.tarmac,
  },
  closeIcon: { width: 16, height: 16, color: neutrals.neutralGrays.ash },
  content: {},
});
